import React from 'react'
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const BodhgayaResidency = () => {
    const carouselBodhgayaResidency = {
        items: 1,
        loop: true,
        dots: false,
        margin: 0,
        autoplay: true,
        nav: true,
        navText: ['<i class="ti-angle-left" aria-hidden="true"></i>', '<i class="ti-angle-right" aria-hidden="true"></i>'],
        responsiveClass: true,
        responsive: {
            0: {
                dots: false,
            },
            600: {
                dots: false,
            },
            1000: {
                dots: false,
            }
        }
    };
    const carouselSravastiResidencythumb = {
        loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    };
    return (
        <>
            <header className="headerslider">
                <OwlCarousel className="owl-theme first-carousel" {...carouselBodhgayaResidency}>
                    <div className="item">
                        <img src="img/slider/Residency-slider-2.jpg" loading="lazy" alt="" className="img-fluid" />
                    </div>
                   
                    <div className="item">
                        <img src="img/slider/Residency-slider-3.jpg" loading="lazy" alt="" className="img-fluid" />
                    </div>
                    <div className="item">
                        <img src="img/slider/Residency-slider-1.jpg" loading="lazy" alt="" className="img-fluid" />
                    </div>

                </OwlCarousel>

                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </header>

            <section className="room-details1 section-padding" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-title">The Residency, Bodhgaya</div>
                        </div>
                        <div className="col-md-8">
                            <p>Our hotel features 50 serene rooms, offering a peaceful retreat for travelers exploring the region's
                                profound Buddhist heritage. Located at a 5 min walking distance to the Mahabodhi temple in Bodhgaya,
                                our property offers a variety on Indian and International cuisines. Safe facility available in all rooms.</p>
                            <p>Bodhgaya, a sacred site in Buddhism, is where Lord Buddha attained enlightenment under the Bodhi Tree. The Mahabodhi Temple Complex, a UNESCO World Heritage Site, is a revered pilgrimage destination for Buddhists worldwide.</p>
                            <p>At The Residency, we blend modern comforts with a deep connection to Bodhgaya's spiritual legacy. The Hotel is Recognized by Department of Tourism, Government of Bihar and We are also Members of FHRAI and HRAEI.</p>
                            <p></p>
                            <div className="row">
                                <div className="col-md-6">
                                    <h6>Check-in</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-in - 2PM</p>
                                            </div>
                                        </li>
                                        {/* <li>
                                    <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                    <div className="page-list-text">
                                        <p>Early check-in subject to availability</p>
                                    </div>
                                </li> */}
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <h6>Check-out</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-out - 12 Noon</p>
                                            </div>
                                        </li>
                                        {/* <li>
                                    <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                    <div className="page-list-text">
                                        <p>Express check-out</p>
                                    </div>
                                </li> */}
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="cont">
                                        <h3>Address</h3>
                                        <p> Adjacent to China Temple, Bodhgaya, <br />Dist. - Gaya - 824231, Bihar (India)
                                            <br /><strong>Mob. No.</strong> : <a href='tel:+91 92893 00357'> +91 92893 00357</a><br />
                                            <strong>Tel No. </strong>: <a href='tel:+0631 - 2201135'>+0631 - 2201135</a><br />
                                            <strong>Email </strong>: <a href='mailto:theresidencybodhgaya@gmail.com'>theresidencybodhgaya@gmail.com,</a> <br />
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 offset-md-1">
                            <h6>Facilities of The Residency</h6>
                            <p>The  Residency provides deluxe air-condition rooms include the following facilities</p>
                            <ul className="mb-30">
                                <li>Multi Cuisine Food</li>
                                <li>24 Hour Hot & Cold Shower</li>
                                <li>Multi-lingual satellite T.V.</li>
                                <li>24 Hour Uninterrupted Power Supply</li>
                                <li>Free High Speed Wi-Fi connectivity</li>
                                <li>Hair Dryer</li>
                                <li>Laundry Services</li>
                                <li>Shopping Arcade</li>
                                <li>Tea / Coffee maker</li>
                                <li>Doctor on call</li>
                                <li>Room service</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rooms5 section-padding bg-white" data-scroll-index="1">
                <div className="container">
                    <div className="section-title">Room Type</div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/b-room-1.jpg" loading="lazy" alt="" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Single Room</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Single Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/b-room-2.jpg" loading="lazy" alt="" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Twin / Double Room</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Twin Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-9.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-9.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-10.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-10.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-11.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-11.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-12.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-12.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-1.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-1.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-3.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-3.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-4.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-4.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-13.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-13.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-14.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-14.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-5.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-5.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-6.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-6.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-7.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-7.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-8.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-8.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-2.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-2.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-15.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-15.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/bodhgaya-16.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/bodhgaya-16.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="section-padding">
                <div className="container">
                    <div className="section-title">Places of Attraction</div>
                    <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidencythumb}>
                        <div className="item thumb">
                            <img src='img/slider/Mahabodhi.jpg' alt='' />
                            <p>Mahabodhi temple</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Dungeshwari.jpg' alt='' />
                            <p>Dungeshwari hills</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Great.jpg' alt='' />
                            <p>Great buddha statue</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Muchalinda.jpg' alt='' />
                            <p>Muchalinda lake</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Vishnupad.jpg' alt='' />
                            <p>Vishnupad temple gaya</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Daijokyo.jpg' alt='' />
                            <p>Daijokyo buddhist temple</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Sujhata.jpg' alt='' />
                            <p>Sujhata Kuti</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/sleeping.jpg' alt='' />
                            <p>Sleeping Buddha</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Niranjana.jpg' alt='' />
                            <p> Niranjana River</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Garh.jpg' alt='' />
                            <p> Sujata Garh Stupa</p>
                        </div>

                    </OwlCarousel>

                </div>
            </section>

            <section className="bg-white">
                <div className="col-md-12">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14499.572058762536!2d84.9681477875732!3d24.696204193801485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f32dc9ff989da5%3A0x7feb4167cc52a7e6!2sThe%20residency%2C%20bodhgaya!5e0!3m2!1sen!2sin!4v1747638218261!5m2!1sen!2sin" width="100%" height="350" frameborder="0" className="mappie" allowfullscreen title="Google Map - The Bodhgaya Residency"></iframe>

                </div>

            </section>

        </>
    )
};

export default BodhgayaResidency;
